/*!
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from "react";

import entries from "lodash/entries";

import { ErrorMessage } from "@hookform/error-message";

import { ErrorMessageDiv, RedText, RedTextDiv } from "./HookErrorMessage.styles";
import { IHookErrorMessageProps } from "./IHookErrorMessageProps";

/**
 * React hook error message component.
 * @component
 * @param {IHookErrorMessageProps} props The props.
 * @returns {React.ReactElement<IHookErrorMessagesProps>} React hook error message component.
 */
export function HookErrorMessage(props: IHookErrorMessageProps): React.ReactElement {
  return (
    <ErrorMessageDiv>
      <ErrorMessage
        errors={props.errors}
        name={props.inputName}
        render={({ message, messages }): React.ReactNode => {
          return messages ? (
            entries(messages).map(([type, message]) => (
              <div key={type} role="alert" aria-relevant="all">
                <RedText className="error"> {message} </RedText>
              </div>
            ))
          ) : (
            <RedTextDiv role="alert" aria-relevant="all">
              <RedText className="error"> {message} </RedText>
            </RedTextDiv>
          );
        }}
      />
    </ErrorMessageDiv>
  );
}
